import React, { useEffect, useState } from "react";
import { Table, Row, Col ,Button , Modal,DatePicker} from "antd";
import appConfig from "../../../helpers/appConfig";
import Home from "../../Home";
import moment from "moment";

const Index = (props) => {
  const [invitations, setInvitations] = useState([]);
  const [onlineDate, setOnlineDate] = useState("");
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalRecords, setTotalRecords] = useState(0); // For total records from API
  const [sorter, setSorter] = useState({}); // To track sorting state
  const [modalVisible, setModalVisible] = useState(false);
  const [modalEmails, setModalEmails] = useState([]); // Emails for modal display

  // // useEffect(() => {
  //   getInvitationsList();
  // }, [page, pageSize, sorter]); // Include dependencies for pagination and sorting


  useEffect(() => {
    console.log("statusChanged--------------")
    setLoading(true);
    const date = onlineDate ? onlineDate : moment().date()._d;
    filterData(date);
}, [page, pageSize, sorter])

  const getInvitationsList = async (postData) => {
    try {
      setLoading(true);
      const sortField = sorter && sorter.field ? sorter.field : "";
      const sortOrder = sorter && sorter.order === "ascend" ? "asc" : "desc";
      

      // const postData = {
      //   startDate: postData.startDate,
      //   endDate: postData.endDate
      // };
      
      const result = await fetch(
        `${appConfig.endpoint}/api/v1/employee/arkiv/branchGivenCoins`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",  // <<-- important
            "x-auth-token": localStorage.getItem("token"),
          },
          body: JSON.stringify(postData),
        }
      );
      

      const data = await result.json();
      if (data) {
        const processedData = data.data.map((item, index) => ({
          ...item,
          serialNo: index + 1 + (page - 1) * pageSize, // Add sequential numbering
        }));

        setInvitations(processedData);
        setTotalRecords(data.totalCount); // Update total records from API
      }
      setLoading(false);
    } catch (error) {
      console.error("Something went wrong:", error);
      setLoading(false);
    }
  };

  const filterData = (date) => {
    setOnlineDate(date)
    const startDate = moment(date);
    const endDate = moment(date).add(1, "days");
    let postData = {
        startDate: startDate,
        endDate: endDate
    }
    console.log("======data=====", postData)
    getInvitationsList(postData)
}

  const backbtn = () => {
    props.history.goBack();
    // props.history.push("/arkiv");
  };

  
  // Show modal with full list of emails
  const showEmailsModal = (emails) => {
    setModalEmails(emails);
    setModalVisible(true);
  };

  const handleModalClose = () => {
    setModalVisible(false);
    setModalEmails([]);
  };
  const getColumnSearchProps = (dataIndex) => {
    const uniqueValues = new Set(
      invitations.map((item) => {
        const keys = dataIndex.split('.');
        let value = item;
        for (let i = 0; i < keys.length; i++) {
          if (value && value[keys[i]] !== undefined) {
            value = value[keys[i]];
          } else {
            value = undefined;
            break;
          }
        }
        return value;
      })
    );
  
    return {
      filters: Array.from(uniqueValues).map((value) => ({
        text: value || "No Data",
        value: value || "",
      })),
      onFilter: (value, record) => {
        const keys = dataIndex.split('.');
        let fieldValue = record;
        for (let i = 0; i < keys.length; i++) {
          if (fieldValue && fieldValue[keys[i]] !== undefined) {
            fieldValue = fieldValue[keys[i]];
          } else {
            fieldValue = undefined;
            break;
          }
        }
        return (
          fieldValue &&
          fieldValue.toString().toLowerCase().includes(value.toLowerCase())
        );
      },
    };
  };
  
  
  
  const tableColumns = [
    {
      title: "Sr. No.",
      dataIndex: "serialNo",
      key: "serialNo",
      width: "5%",
      render: (serialNo) => <center>{serialNo ? serialNo : ""}</center>,
    },
    {
      title: "Invoice  No",
      dataIndex: "invoiceNumber",
      key: "invoiceNumber",
      width: "10%",
      render: (text, record) => (
        <>
          <center>{record.invoiceNumber ? record.invoiceNumber :""}</center>
        </>
      ),
    },
    // {
    //   title: "Branch Name",
    //   dataIndex: "branch",
    //   key: "branch",
    //   width: "15%",
    //   // ...getColumnSearchProps("branch"), // Ant Design filter
    //   render: (text) => <strong>{text}</strong>,
    // },
    {
      title: "Coins Given",
      dataIndex: "coinsGiven",
      key: "coinsGiven",
      width: "10%",
      sorter: (a, b) => {
        return new Date(a.coinsGiven) - new Date(b.coinsGiven);
      },
      sortDirections: ["ascend", "descend"],
      render: (text, record) => (
        <>
          <center>{record.coinsGiven ? record.coinsGiven :""}</center>
        </>
      ),
    },
      {
        title: 'Order Total Price',
        key: 'totalPrice',
        width: "15%",
        render: (text, record) => (
          <>
            <center>Kr. {record.totalPrice ? record.totalPrice :""}</center>
          </>
        ),
      },    
      {
        title: "Customer Information",
        key: "userInformation",
        width: "15%",
        render: (text, record) => {
          const email = record.customer.email || '';
          const phone = record.customer.phoneNo ? `+${record.customer.countryCode || '+47'} ${record.customer.phoneNo}` : '';
      
          return (
            <center>
              {email && <div>{email}</div>}
              {phone && <div>{phone}</div>}
            </center>
          );
        },
      },   
    {
      title: "Date",
      key: "createdAt",
      width: "15%",
      //sorter: true,
      sorter: (a, b) => {
        return new Date(a.createdAt) - new Date(b.createdAt);
      },
      sortDirections: ["ascend", "descend"],
      render: (text, record) => (
        <center>{new Date(record.createdAt).toLocaleString()}</center>
      ),
    },

  ];
  const goBackMainPage = () => {
    props.history.push("/arkiv/tfl-rapport");
  };
//invitedByDifferentUsersCount
  return (
   <Home>
    <div className="report-container">
          <span className="item" style={{ width: "60%" }}>
           <span>Arkiv : </span> TFL Agent Coins Given List
          </span>
          <span id="less-visible">
           <Button
               onClick={() => goBackMainPage()}
               className="ant-btn back-btn"
             >
              <i className="fa fa-arrow-circle-left" aria-hidden="true" />
           </Button>
          </span>
         </div>
     <div>
      <>
      <div className="column">
                <div className="p-2">
                                                <DatePicker
                                                    onChange={(date, dateString) => {
                                                        filterData(date)
                                                    }}
                                                    format="YYYY-MM-DD"
                                                    placeholder="Select day"
                                                />
                                            </div>
                 <div className="p-4">
                 <Table
                    bordered
                    loading={loading}
                    dataSource={invitations}
                    columns={tableColumns}
                    pagination={{
                      total: totalRecords,
                      current: page,
                      pageSize: pageSize,
                    //   showSizeChanger: true,
                    //   pageSizeOptions: ["5", "10", "20"],
                      onChange: (current, size) => {
                        setPage(current);
                        setPageSize(size);
                      },
                    }}
                    onChange={(pagination, filters, sorter) => {
                      const { current, pageSize } = pagination;
                      setPage(current);
                      setPageSize(pageSize || 10);
                      setSorter(sorter); // Update sorting state
                    }}
                  ></Table>
                 </div>
                </div>

         {/* Modal for displaying full email list */}
         <Modal
          title="Full Email List"
          visible={modalVisible}
          onCancel={handleModalClose}
          footer={[
            <Button key="close" onClick={handleModalClose}>
              Close
            </Button>,
          ]}
        >
          <ul>
            {modalEmails.map((email, index) => (
              <li key={index}>{email}</li>
            ))}
          </ul>
        </Modal>
      </>
    </div>
   </Home>
  );
};

export default Index;
